import { Box, Typography } from '@mui/material';

import { ClinicalStatus } from '../../../admin/constants/general';
import { ClinicalRelationships } from '../../../constants';
import { formatEntityId } from '../../../helpers';
import {
  AssignmentMap,
  cardChipStyles,
  ClinicalRelationshipColorMap,
  ClinicalStatusMap,
} from '../constants';
import { FORTA_BLUE, FORTA_WHITE } from '../../../utils/colors';
import { ENTITY_PREFIX } from '../../../constants';

import type { IProviderAssignment } from '../../../utils/types';

interface ClientCardProps {
  assigmment: IProviderAssignment;
  onClick: (assigmment: IProviderAssignment) => void;
}

function ClientCard({ assigmment, onClick }: ClientCardProps) {
  const { client, clinical_relationship } = assigmment;
  const assignmentLabel =
    clinical_relationship === ClinicalRelationships.HomeBcba ||
    clinical_relationship === ClinicalRelationships.BobbingBcba ||
    clinical_relationship === ClinicalRelationships.SubstituteBCBA
      ? AssignmentMap[clinical_relationship]
      : undefined;
  const clinicalStatus = client?.clinical_status;
  const clinicalStatusColor =
    clinicalStatus === ClinicalStatus.CLINICAL || clinicalStatus === ClinicalStatus.PRE_CLINICAL
      ? ClinicalRelationshipColorMap[clinicalStatus]
      : undefined;
  const clinicalStatusLabel =
    clinicalStatus === ClinicalStatus.CLINICAL || clinicalStatus === ClinicalStatus.PRE_CLINICAL
      ? ClinicalStatusMap[clinicalStatus]
      : null;
  return (
    <Box
      onClick={() => onClick(assigmment)}
      sx={{
        p: 2,
        backgroundColor: FORTA_WHITE,
        borderRadius: '8px',
        cursor: 'pointer',
        border: `1px solid ${FORTA_BLUE.light1}`,
        '&:hover': {
          boxShadow: `1px 2px 4px rgba(0, 0, 0, 0.2)`,
        },
      }}
    >
      <Typography
        textAlign={'left'}
        fontSize={18}
        color={FORTA_BLUE.dark}
      >{`${client?.first_name} ${client?.last_name}`}</Typography>
      <Box sx={{ display: 'flex', mt: 1, flexWrap: 'wrap' }}>
        <Typography sx={cardChipStyles} mt={1}>
          {formatEntityId(client?.id ?? '', ENTITY_PREFIX.Client)}
        </Typography>
        <Typography sx={cardChipStyles} mt={1} noWrap>
          {assignmentLabel}
        </Typography>
        <Box sx={{ ...cardChipStyles, display: 'flex', alignItems: 'center', p: 0, mt: 1 }}>
          <Box
            sx={{
              width: 14,
              height: 14,
              borderRadius: '50%',
              p: 0,
              ml: 1,
              backgroundColor: clinicalStatusColor,
            }}
          />
          <Typography sx={{ ...cardChipStyles, mr: 0 }} noWrap>
            {clinicalStatusLabel}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default ClientCard;
